(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* Reveal on scroll */
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
  }, { threshold: 0.12 });
  const observeReveals = () => $$('.reveal:not(.is-visible)').forEach((el) => io.observe(el));
  observeReveals();

  /* Mobile menu */
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-mobile-toggle]');
    if (t) $('[data-mobile-menu]')?.classList.toggle('is-open');
  });

  /* Sliders */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-slide]');
    if (!btn) return;
    const slider = $('[data-slider]', btn.closest('[data-slider-root]'));
    if (!slider) return;
    const step = slider.firstElementChild ? slider.firstElementChild.offsetWidth + 24 : 320;
    slider.scrollBy({ left: btn.dataset.slide === 'next' ? step : -step, behavior: 'smooth' });
  });
  $$('[data-autoplay="true"]').forEach((root) => {
    const slider = $('[data-slider]', root);
    if (!slider) return;
    let paused = false;
    root.addEventListener('pointerenter', () => (paused = true));
    root.addEventListener('pointerleave', () => (paused = false));
    setInterval(() => {
      if (paused) return;
      const step = slider.firstElementChild ? slider.firstElementChild.offsetWidth + 24 : 320;
      const end = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 8;
      slider.scrollTo({ left: end ? 0 : slider.scrollLeft + step, behavior: 'smooth' });
    }, 3800);
  });

  /* Cart drawer */
  const drawer = () => $('[data-cart-drawer]');
  const openCart = () => drawer()?.classList.add('is-open');
  const closeCart = () => drawer()?.classList.remove('is-open');

  async function refreshCart() {
    const res = await fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + '?section_id=cart-drawer' : '/?section_id=cart-drawer');
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-contents]');
    const target = $('[data-cart-contents]');
    if (fresh && target) target.innerHTML = fresh.innerHTML;
    const count = doc.querySelector('[data-cart-count]');
    $$('[data-cart-count]').forEach((el) => { el.textContent = count ? count.textContent : el.textContent; el.hidden = !count || count.textContent.trim() === '0'; });
    observeReveals();
  }

  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }

    const change = e.target.closest('[data-line-change]');
    if (change) {
      const { line, qty } = change.dataset;
      await fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
      });
      refreshCart();
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  /* AJAX add to cart */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    const label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    try {
      await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
      await refreshCart();
      openCart();
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = label; }
    }
  });

  /* Variant selection on product page */
  $$('[data-variant-selects]').forEach((wrap) => {
    const variants = JSON.parse(wrap.querySelector('[data-variant-json]').textContent);
    const idInput = wrap.querySelector('[data-variant-id]');
    const priceEl = wrap.querySelector('[data-variant-price]');
    const submit = wrap.querySelector('[type=submit]');
    wrap.addEventListener('change', () => {
      const chosen = $$('select[data-option]', wrap).map((s) => s.value);
      const match = variants.find((v) => v.options.every((o, i) => o === chosen[i]));
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (submit) { submit.disabled = !match.available; submit.textContent = match.available ? 'Add to cart' : 'Sold out'; }
    });
  });
})();
